import styled from "styled-components";

export const StyledDiv = styled.div`
  text-align: center;
  margin: 0 15pt;
  width: 100pt;
`;
